export default {
    cognito: {
      REGION: "us-east-2",
      USER_POOL_ID: "us-east-2_7YgxDqiTc",
      APP_CLIENT_ID: "4200vk0jhc7tf7iko29k8mvorh",
    }
};